import logs from "../utils/logs";
let commonDatas = "";

const commonDataLoad = async (callBackFn) => {
  await fetch(
    process.env.REACT_APP_YOUFACTORS_TRANSLATION_URL + "commondata.json"
  )
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      console.log("common load success ", data);
      commonDatas = data;
    })
    .finally(() => (callBackFn ? callBackFn() : null))
    .catch(function (err) {
      logs(err, " error");
    });
};

const getCurrencies = () => {
  return commonDatas.currencies;
};
const getCurrency = (x) => {
  return commonDatas.currencies[x];
};
const getTimeZones = () => {
  return commonDatas.timezone;
};
const getTimeZone = (x) => {
  return commonDatas.timezone[0];
};
const getLanguages = () => {
  return Object.values(commonDatas.languages).sort((a, b) => {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
};
const getLanguage = (x) => {
  return commonDatas.languages[x];
};
const getDateFormats = () => {
  return commonDatas.dateformats;
};
const getDateFormat = (x) => {
  return commonDatas.dateformats[x];
};
const getTimeFormats = () => {
  return commonDatas.timeformats;
};
const getTimeFormat = (x) => {
  return commonDatas.timeformats[x];
};
const getDatenewFormats = () => {
  return commonDatas.datenewformats;
};
const getDatenewFormat = (x) => {
  return commonDatas.datenewformats[x];
};
const getTimenewFormats = () => {
  return commonDatas.timenewformats;
};
const getTimenewFormat = (x) => {
  return commonDatas.timenewformats[x];
};

export {
  commonDataLoad,
  getCurrencies,
  getCurrency,
  getTimeZones,
  getTimeZone,
  getLanguages,
  getLanguage,
  getDateFormats,
  getDateFormat,
  getTimeFormats,
  getTimeFormat,
  getDatenewFormats,
  getDatenewFormat,
  getTimenewFormats,
  getTimenewFormat,
};
